import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap';
import { Form, Schema, SelectPicker } from 'rsuite';
import credentialService from '../../../../../services/Internal/Credential/credential.service';
import { getCredStatus, getCredStatusReason } from '../../../../../services/Shared/codeTable.service';
import RedStar from '../../../../Shared/GenericComponents/RedStar';

function LegacyPlsCredentialForm(props) {
    const [formData, setFormData] = useState({
        entityId:props.entityId,
        formattedLicenseNumber: "",
        status: "",
        statusReason:"",
        firstIssuanceDate:null,
        effectiveDate: null,
        expirationDate: null,
        applicationDate: null,
        applicationType:"Professional Surveyor (Legacy)",
        reinstatementDate: null,
        approvedBy:"",
        userMod:"",
        dateMod:null
    });
    const [credStaus, setCredStaus] = useState([])
    const [credReason, setCredReason] = useState([])
    useEffect(() => {
        getCredStatus().then(setCredStaus);
    }, [])

    const { ObjectType } = Schema.Types;
    const model = Schema.Model({
        statusReason: ObjectType().isRequired('This field is required.'),
        status: ObjectType().isRequired('This field is required.'),

    })

    const handleCredentialStatusChange = (val) => {
        setFormData({ ...formData, status: val, statusReason: null })
        getCredStatusReason(val?.id, val?.status).then(setCredReason);
    }

    const submitForm = (validation, event) => {
        if (validation) {
            var dataToTransmit = {
                ...formData
            }
            credentialService.createLegacyPlsCredential(dataToTransmit).then((response) => {
                props.saveSuccess(response.data);
            });
        }
    }
    return (
        <Form id={props.formId} fluid model={model} formValue={formData} onChange={setFormData} onSubmit={submitForm} >
            <Row className="mb-3">
                <Col>
                    <Form.ControlLabel><b>Credential #</b></Form.ControlLabel>
                    <Form.Control name="formattedLicenseNumber" />
                </Col>
                <Col>
                    <Form.ControlLabel><b>Credential Status</b> <RedStar /></Form.ControlLabel>
                        <Form.Control
                            name="status"
                            block
                            data={credStaus}
                            accepter={SelectPicker}
                            searchable={false}
                            placeholder="Select Status"
                            onChange={handleCredentialStatusChange} /> 
                </Col>
                <Col>
                    <Form.ControlLabel><b>Credential Reason</b> <RedStar /></Form.ControlLabel>
                        <Form.Control
                            name="statusReason"
                            block
                            data={credReason}
                            accepter={SelectPicker}
                            searchable={false}
                            readOnly={!formData.status}
                            placeholder="Select Status Reason" /> 
                </Col>

            </Row>
            <Row className="mb-3">
                <Col>
                    <Form.ControlLabel><b>First Issuance Date</b></Form.ControlLabel>
                    <Form.Control name="firstIssuanceDate" type="date" />
                </Col>
                <Col>
                    <Form.ControlLabel><b>Effective Date</b></Form.ControlLabel>
                    <Form.Control name="effectiveDate" type="date" />
                </Col>
                <Col>
                    <Form.ControlLabel><b>Expiration Date</b></Form.ControlLabel>
                    <Form.Control name="expirationDate" type="date" />
                </Col>
            </Row>
            <Row className="mb-3">
                <Col>
                    <Form.ControlLabel><b>Application Date</b></Form.ControlLabel>
                    <Form.Control name="applicationDate" type="date" />
                </Col>
                <Col>
                    <Form.ControlLabel><b>Application Type</b></Form.ControlLabel>
                    <Form.Control name="applicationType" disabled />
                </Col>
                <Col>
                    <Form.ControlLabel><b>Reinstatement Date</b></Form.ControlLabel>
                    <Form.Control name="reinstatementDate" type="date" />
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.ControlLabel><b>Licensed By</b></Form.ControlLabel>
                    <Form.Control name="approvedBy" />
                </Col>
                <Col>
                    <Form.ControlLabel><b>Date of Last Activity</b></Form.ControlLabel>
                    <Form.Control name="dateMod" type="date" />
                </Col>
            </Row>
        </Form>
    );
}

export default LegacyPlsCredentialForm;